// extracted by mini-css-extract-plugin
export var root = "TaxEquivalentCalculator-module--root--Lqbrd";